import React from 'react';
import { useNavigate } from 'react-router-dom';
import './project-item.css';
import { PROJECTS_CLICKABLE } from '../../utils/buildConfig.js';
import DemoGallery from '../demo-gallery/demo-gallery.js';
import TimelineDivider from '../timeline-divider/timeline-divider.js';
import ThemedContainer from '../themed-container/themed-container.js';

// Check if we're in a build that includes project routes
const isProjectRoutesAvailable = () => {
    try {
        require('../../data/projects-latest.js');
        return true;
    } catch (error) {
        return false;
    }
};

function renderMediaContent(item, priority = false) {
    if (item.content) return item.content;
    if (item.src) {
        return (
            <img
                src={item.src}
                alt={item.alt || ''}
                loading={priority ? 'eager' : 'lazy'}
                decoding="async"
                fetchPriority={priority ? 'high' : 'low'}
            />
        );
    }
    return null;
}

export default function ProjectItem({ title, description, slug, projectData, externalLink, media, priority = false }) {
    const navigate = useNavigate();
    const mediaItems = media || projectData?.media;
    const hasMedia = Array.isArray(mediaItems) && mediaItems.length > 0;
    
    // Determine if item is clickable and what type of click action
    // External links work on both builds, internal project navigation only on latest
    const isExternalLink = !!externalLink;
    const isInternalProject = !!(slug && isProjectRoutesAvailable());
    const isClickable = isExternalLink || (PROJECTS_CLICKABLE && isInternalProject);
    
    const handleTitleClick = () => {
        if (isExternalLink) {
            // Open external link in new tab
            window.open(externalLink, '_blank', 'noopener,noreferrer');
        } else if (isInternalProject) {
            // Navigate to internal project page (only available in latest builds)
            navigate(`/${slug}`);
        }
    };

    return (
        <>
            <div className="project-row">
                <TimelineDivider />
                <div 
                    className={`project-item ${isClickable ? 'project-item-clickable' : ''}`}
                    onClick={isClickable ? handleTitleClick : undefined}
                >
                    <div className="project-item__row">
                        <div className="project-item-content">
                            <h3 className="text-project-title">
                                {title}
                                {isExternalLink && (
                                    <span className="external-link-indicator"> ↗</span>
                                )}
                            </h3>
                            <p className="text-description">{description}</p>
                            {/*<DemoGallery items={projectData?.demoItems} />*/}
                        </div>
                    </div>
                    {hasMedia ? (
                        <div className="project-item__media">
                            {mediaItems.map((item, index) => {
                                const span = item.span === 'half' ? 'half' : 'full';
                                return (
                                    <div
                                        key={item.alt || item.src || index}
                                        className={`project-item__media-item project-item__media-item--${span}`}
                                    >
                                        <ThemedContainer theme={item.theme} padding={item.padding} shadow={item.shadow} maxWidth={item.maxWidth} align={item.align} radius={item.radius}>
                                            {renderMediaContent(item, priority && index === 0)}
                                        </ThemedContainer>
                                    </div>
                                );
                            })}
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    );
}
